import { html, css } from 'lit';
import KaiElement from '../base';

class OneLineListElement extends KaiElement {
  static get is() {
    return 'kai-1line-listitem';
  }

  static get properties() {
    return {
      text: { type: String },
      reorder: { type: Boolean },
      marquee: { type: Boolean },
      singleline: { type: Boolean },
      disabled: { type: Boolean, attribute: 'disabled', reflect: true },
    };
  }

  static get styles() {
    return [
      super.styles,
      /* eslint-disable */
      css`
        .container {
          display: flex;
          width: 100%;
          min-height: 6rem;
          align-items: center;
          padding-left: 2rem;
          padding-right: unset;
          box-sizing: border-box;
        }

        .container:-moz-dir(rtl) {
          padding-left: unset;
          padding-right: 2rem;
        }

        .listitem {
          background: var(--listitem-background-color, var(--color-gs00));
          color: var(--color-gs100);
        }

        .listitem.enabled:active {
          background-color: var(--color-gs10);
        }

        .reorder {
          box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 0, 0, 0.3);
          background: var(--color-gs100);
          color: var(--color-gs00);
        }

        .container ::slotted([slot='listitem-left-slot']) {
          margin-right: 1.5rem;
          margin-left: unset;
          font-size: 3.2rem;
          white-space: nowrap;
          box-sizing: border-box;
        }

        .container ::slotted([slot='listitem-left-slot']):-moz-dir(rtl) {
          margin-left: 1.5rem;
          margin-right: unset;
        }

        .middle-children {
          margin: 1.8rem 2rem 1.8rem 0;
          flex-grow: 1;
          width: 100%;
          overflow-x: hidden;
          word-wrap: break-word;
        }

        .middle-children:-moz-dir(rtl) {
          margin: 1.8rem 0 1.8rem 2rem;
        }

        .reorder ::slotted([slot='listitem-right-slot']) {
          color: var(--color-gs20);
        }

        .container ::slotted([slot='listitem-right-slot']) {
          margin: 0 1.5rem 0 -0.5rem;
          font-size: 3.2rem;
          white-space: nowrap;
        }

        .container ::slotted([slot='listitem-right-slot']):-moz-dir(rtl) {
          margin: 0 -0.5rem 0 1.5rem;
        }

        .container ::slotted([slot='listitem-right-slot'])[data-icon='menu'] {
          color: var(--color-gs60);
        }

        .container ::slotted([slot='listitem-right-slot'])[data-icon='forward'] {
          color: var(--color-gs20);
        }

        .content {
          text-align: left;
          white-space: pre-wrap;
        }

        .singleline {
          overflow: hidden;
          white-space: pre;
          text-overflow: ellipsis;
        }

        .listitem.disabled {
          opacity: 1;
          pointer-events: none;
        }

        .listitem.disabled .middle-children,
        .listitem.disabled ::slotted([slot='listitem-left-slot']),
        .listitem.disabled ::slotted([slot='listitem-center-slot']),
        .listitem.disabled ::slotted([slot='listitem-right-slot']) {
          opacity: var(--disabled-opacity);
          pointer-events: none;
        }

        :-moz-dir(rtl) .content,
        :-moz-dir(rtl) .subtitle-1 {
          text-align: right;
        }
      `,
      /* eslint-enable */
    ];
  }

  constructor() {
    super();
    this.reorder = false;
    this.marquee = false;
    this.singleline = false;
    this.disabled = false;
  }

  render() {
    return html`
      <div
        class="container
        ${!this.reorder ? 'listitem' : 'reorder'}
        ${this.disabled ? 'disabled' : 'enabled'} "
      >
        <slot name="listitem-left-slot"></slot>
        <div class="middle-children">
          <slot name="listitem-center-slot"></slot>
          ${this.marquee
            ? html`
                <marquee class="subtitle-1" dir="auto">
                  ${this.text}
                </marquee>
              `
            : html`
                <div
                  class="subtitle-1 content ${this.singleline
                    ? 'singleline'
                    : ''}"
                  dir="auto"
                >${this.text}</div>
                <!-- because we use white-space: pre(-wrap),
                so the html format cannot be changed or it will
                generate redundant spaces -->
              `}
        </div>
        <slot name="listitem-right-slot"></slot>
      </div>
    `;
  }
}

customElements.define(OneLineListElement.is, OneLineListElement);
